import { abasPermitidas } from './projetos';

// Abas (sub-páginas) do Painel e do Detalhe da emissão num lugar só — usadas
// pelas abas da página (PageTabs, em Painel2/Detalhe2) e pelo dropdown da
// NavBar, que precisam listar exatamente as mesmas.
// `id` = id interno da aba; `slug` = segmento da URL (/painel/<slug>,
// /emissoes/:id/<slug>); `icon` só aparece no dropdown da NavBar.

// Flag temporária pra remover a aba Obrigações (Painel e emissão) sem apagar
// o código. Desde 27/10/2026 Obrigações é só do projeto BTG: no Painel, só na
// visão BTG (abasPainel); na emissão, só nas do projeto 2 (abasPermitidas,
// services/projetos.js).
export const SHOW_OBRIGACOES = true; // TODO: true pra reativar Obrigações

// Flag temporária pra remover a aba Fluxo de Caixa do Painel sem apagar o
// código (só existe no Painel: sem equivalente por emissão).
export const SHOW_FLUXO_CAIXA = false; // TODO: true pra reativar Fluxo de Caixa

const ABAS_PAINEL = [
  { id: 'enquadramento', slug: 'enquadramento',    label: 'Enquadramento',       icon: 'shield-check' },
  { id: 'carteira',      slug: 'carteira',         label: 'Carteira',            icon: 'wallet' },
  { id: 'fluxo',         slug: 'fluxo-pagamentos', label: 'Fluxo de Pagamentos', icon: 'banknote' },
  { id: 'obrigacoes',    slug: 'obrigacoes',       label: 'Obrigações',          icon: 'clipboard-list' },
  { id: 'fluxo-caixa',   slug: 'fluxo-caixa',      label: 'Fluxo de Caixa',      icon: 'landmark' },
];

// Visão BTG do Painel (SeletorProjeto): só Enquadramento e Obrigações. Visão
// Leverage: o resto, sem Obrigações (só do BTG).
const ABAS_PAINEL_BTG = ['enquadramento', 'obrigacoes'];

export function abasPainel(visaoBtg = false) {
  return ABAS_PAINEL.filter(a => (SHOW_OBRIGACOES || a.id !== 'obrigacoes') && (SHOW_FLUXO_CAIXA || a.id !== 'fluxo-caixa')
    && (visaoBtg ? ABAS_PAINEL_BTG.includes(a.id) : a.id !== 'obrigacoes'));
}

const ABAS_EMISSAO = [
  { id: 'caracteristicas', slug: 'caracteristicas',  label: 'Carc. da Emissão',         icon: 'info' },
  { id: 'enquadramento',   slug: 'enquadramento',    label: 'Enquadramento',            icon: 'shield-check' },
  { id: 'obrigacoes',      slug: 'obrigacoes',       label: 'Obrigações',               icon: 'clipboard-list' },
  { id: 'fluxo',           slug: 'fluxo-pagamentos', label: 'PU e Fluxo de Pagamentos', icon: 'banknote' },
  { id: 'documentos',      slug: 'documentos',       label: 'Documentos',               icon: 'file-text' },
];

// Flag temporária pra tirar do ar o Dash. BTG ("Controle de Obrigações") sem
// apagar o código (27/10/2026). Desligada, some de todo lugar: rota
// /btg/dashboard-btg e /interno/dashboard-btg (link direto cai no Painel/
// /interno), item "Dash. BTG" da NavBar, card em /escolha e aba/card da Área
// Interna. Cliente BTG deixa de passar por /escolha (vai direto pro Painel),
// porque temAcessoBtgDashboard (NavBar.jsx) passa a dar false.
export const SHOW_DASHBOARD_BTG = false; // TODO: true pra reativar o Dash. BTG

// Ferramentas da Área Interna (/interno/<slug>, só equipe Leverage) — os
// cards e as abas de Interno.jsx e o dropdown "Interno" da NavBar. `desc`/
// `logo` só aparecem nos cards.
const TODAS_ABAS_INTERNO = [
  { id: 'rodar-relatorio', slug: 'rodar-relatorio', label: 'Rodar Relatório', icon: 'terminal',
    desc: 'Dispara a geração de relatórios (ETL/PDF) por emissão e período.' },
  { id: 'validacao-pu', slug: 'validacao-pu', label: 'Validação de PU', icon: 'badge-check',
    desc: 'Compara o PU calculado pela Securitizadora com o publicado pelo Agente Fiduciário, em todas as emissões.' },
  { id: 'base-operacoes', slug: 'base-operacoes', label: 'Base de Operações', icon: 'database',
    desc: 'Características de todas as séries de todas as emissões (formato Contabilidade/Tesouraria), com exportação para Excel.' },
  { id: 'dashboard-btg', slug: 'dashboard-btg', label: 'BTG - Controle de Obrigações', icon: 'clipboard-list',
    desc: 'Monitoramento de obrigações, garantias e covenants.', logo: '/Btg-logo-blue.svg' },
  { id: 'correspondencia-btg', slug: 'correspondencia-btg', label: 'BTG - Correspondência', icon: 'link-2',
    desc: 'Revisão da correspondência Monitoramento x Summary: aprovar, reprovar e ignorar linhas por emissão, a partir do arquivo da pasta 05. Monitoramento BTG.', logo: '/Btg-logo-blue.svg' },
];
export const ABAS_INTERNO = TODAS_ABAS_INTERNO.filter(a => SHOW_DASHBOARD_BTG || a.id !== 'dashboard-btg');

// Colocar aqui cada um dos artefatos seguindo o padrão:
// (o ícone é sempre a marca do Claude — LucideIcon "claude"):
//   { id: 'exemplo', label: 'Exemplo', desc: 'O que ele faz.', href: 'link' },
export const ARTEFATOS_INTERNO = [
    { id: 'MetaOperacao', label: 'Meta de Operações', desc: 'Acompanhamento das operações', href: 'https://claude.ai/artifact/3D8GiKF7Sk99DSWrB3xUJm?sk=hEEQFAzLh347EypR-DB05A' },
    { id: 'Manuais', label: 'Manuais de Processos', desc: 'Manuais das Operações', href: 'https://claude.ai/artifact/21kFKBz7AnTQ6F1E4T582H?sk=9PhXJH8aywABFtAAFw-RpQ' },  
  { id: 'Due Diligence', label: 'Radar DD', desc: 'Status da DD', href: 'https://claude.ai/artifact/7tgKju475k9q1Swc5DzFXu?sk=uj-rsuHCr_ka8ndVo2rtZw' },
  // adicionar os outros aqui, só copiar e colar a linha de cima, do { até o }, e depois editar os valores.
  
];

// Nome da emissão como o seletor do Detalhe mostra (EmissaoSwitcher) — usado
// no dropdown "Emissões" da NavBar.
export function nomeEmissao(em) {
  if (!em) return '';
  return em.nomeExibicao || `${em.codigo ? `${em.codigo}_` : ''}${em.nome || ''}`;
}

// Emissão sem Akrual (BTG) não tem PU/Fluxo; o projeto ainda pode restringir
// as abas (abasPermitidas, services/projetos.js).
export function abasEmissao(emissao, user, simulaCliente = false) {
  const permitidas = abasPermitidas(emissao, user, simulaCliente);
  const semAkrual = !!emissao && emissao.possuiDadosAkrual === false;
  return ABAS_EMISSAO.filter(a => (SHOW_OBRIGACOES || a.id !== 'obrigacoes')
    && !(semAkrual && a.id === 'fluxo')
    && (!permitidas || permitidas.includes(a.id)));
}
